/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import Fade from 'react-reveal/Fade';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

import MicrositeSection from '../MicrositeSection';

class MicrositeSectionBasic extends MicrositeSection {
    constructor(props) {
        super(props);
    }

    render() {
        let content = this.renderIntroduction();

        return (
            <MicrositeSection
                id={this.props.id}
                name={this.props.name}
                textCentered={this.props.textCentered}
                colorTheme={this.props.colorTheme}
                content={content}
            />
        );
    }

    /**
     * Render introduction to a section
     * @returns {XML}
     */
    renderIntroduction(){
        let content = [];
        let introduction = this.props.introduction;

        if (introduction){
            introduction.map((part, index) => {
                if (typeof part === 'object'){
                    if (part.title){
                        content.push(<Fade key={index + "title"}><h4 className="centered">{part.title}</h4></Fade>);
                    }
                    if (part.text){
                        content.push(<Fade key={index + "text"}><p className="centered">{part.text}</p></Fade>);
                    }
                    if (part.list){
                        content.push(<Fade><span className="list-headline">{part.list.title}</span></Fade>);

                        let listItems = [];
                        part.list.items.map(item => {
                            listItems.push(<li key={item}>{item}</li>);
                            return listItems;
                        });

                        content.push(<Fade><ul className="classic-list">{listItems}</ul></Fade>);
                    }
                    if (part.image){
                        let cls = "section-image";
                        if (part.image.className){
                            cls += " " + part.image.className;
                        }

                        content.push(<Fade key={"image-" + index} left cascade distance="50px" delay={500}><img className={cls} alt="Section image" src={require("../../../../../resources/img/" + part.image.source)}/></Fade>);
                    }
                } else {
                    content.push(<Fade key={index}><p className="centered">{part}</p></Fade>);
                }
                return content;
            });
        }

        return (
            <Row key={this.props.id + "-row-introduction"} className="show-grid section-introduction">
                <Col xs={12} sm={10} smOffset={1} md={10} mdOffset={1} lg={8} lgOffset={2}>
                    {content}
                </Col>
            </Row>
        );
    }

    /**
     * Render grid container
     * @param containerClass {string} class name of container
     * @param maxItemsInRow {number} max number of items in a row
     * @param data {Array} list of items
     * @returns {XML}
     */
    renderGrid(containerClass, maxItemsInRow, data){
        let content = [];

        if (maxItemsInRow > 3 || maxItemsInRow < 1){
            maxItemsInRow = 2;
        }

        let numOfPanels = data.length;
        let numOfFullRows = Math.floor(numOfPanels / maxItemsInRow);
        let panelsInLastRow = numOfPanels % maxItemsInRow;

        let j = null;
        for (let i = 0; i < numOfFullRows; i++){
            let firstIndex = i * maxItemsInRow;
            let lastIndex = ((i+1) * maxItemsInRow);
            let row = this.renderRow(maxItemsInRow, data.slice(firstIndex, lastIndex), i);
            content.push(row);
            j = i+1;
        }

        let lastRow = this.renderRow(panelsInLastRow, data.slice(-panelsInLastRow), j);
        content.push(lastRow);

        return (
            <div key={this.props.id + "-" + containerClass} className={containerClass}>
                {content}
            </div>
        );
    }

    /**
     * Render Row with a number of Columns in panelsInRow
     * @param panelsInRow {number}
     * @param data {Array}
     * @param index {number}
     * @returns {XML}
     */
    renderRow(panelsInRow, data, index){
        let content = null;

        switch (panelsInRow) {
            case 3:
                content = (
                    <Row key={this.props.id + "-row-" + index} className="show-grid equal-height">
                        <Col sm={12} md={4} lg={4}>
                            {this.renderItem(data[0])}
                        </Col>
                        <Col sm={12} md={4} lg={4}>
                            {this.renderItem(data[1])}
                        </Col>
                        <Col sm={12} md={4} lg={4}>
                            {this.renderItem(data[2])}
                        </Col>
                    </Row>
                );
                break;
            case 2:
                content = (
                    <Row key={this.props.id + "-row-" + index} className="show-grid equal-height">
                        <Col sm={6} md={5} mdOffset={1} lg={4} lgOffset={2} className="left">
                            {this.renderItem(data[0])}
                        </Col>
                        <Col sm={6} md={5} lg={4} className="right">
                            {this.renderItem(data[1])}
                        </Col>
                    </Row>
                );
                break;
            case 0:
                break;
            default:
                content = (
                    <Row key={this.props.id + "-row-" + index} className="show-grid">
                        <Col sm={6} smOffset={3} md={6} mdOffset={3} lg={4} lgOffset={4} className="center">
                            {this.renderItem(data[0])}
                        </Col>
                    </Row>
                );
        }

        return content;
    }
}

MicrositeSectionBasic.propTypes = {
    introduction: PropTypes.array,
};

export default MicrositeSectionBasic;